import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { putRecordatorio } from '../../routing/routes';
import LoadingGIF from '../assets/loading.gif';
import Reminders from './RemindersComponent';

const ModifyReminders = ({ recordatorios, archivos, functionesChatbot, refreshData, setNotification, nodos }) => {
	const { id } = useParams();
	const [recordatorio, setRecordatorio] = useState(null);
	const history = useHistory();

	useEffect(() => {
		if (recordatorios) {
			const { global, genericos } = recordatorios;
			if (global && global._id === id) {
				setRecordatorio(global);
			} else {
				setRecordatorio(genericos.find((recordatorio) => recordatorio._id === id));
			}
		}
	}, [recordatorios, id]);

	function saveRecordatorio(nuevoRecordatorio) {
		const tmp = { ...nuevoRecordatorio };
		delete tmp._id;
		putRecordatorio(nuevoRecordatorio._id, tmp)
			.then(() => {
				setNotification('mrecordatorio editado correctamente!');
				refreshData();
				history.push('/recordatorios');
			})
			.catch(() => {
				setNotification('mNo ha sido posible editar el recordatorio!');
				refreshData();
				history.push('/recordatorios');
			});
	}

	if (recordatorio) {
		return (
			<Reminders
				recordatorio={recordatorio}
				archivos={archivos}
				refreshData={refreshData}
				setNotification={setNotification}
				functionesChatbot={functionesChatbot}
				nodos={nodos}
				operacion={saveRecordatorio}
			/>
		);
	} else {
		return (
			<div style={{ margin: '100px 0px' }}>
				<h3 style={{ textAlign: 'center' }}>CARGANDO...</h3>
				<div style={{ textAlign: 'center' }}>
					<span>
						<img style={{ height: '200px', width: '200px' }} src={LoadingGIF} alt={'Cargando'} />
					</span>
				</div>
			</div>
		);
	}
};

export default ModifyReminders;
